import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

export enum EMAIL_CAMPAIGN_UNSUBSCRIBE_PAGE_SERVICES {
  EmailCampaignUnsubscribePageService,
  EmailCampaignUnsubscribePageRepository,
}

export type EmailCampaignUnsubscribePageServices = keyof typeof EMAIL_CAMPAIGN_UNSUBSCRIBE_PAGE_SERVICES

export const EMAIL_CAMPAIGN_UNSUBSCRIBE_PAGE_SERVICES_TYPES =
  makeServicesTypesFromEnum<EmailCampaignUnsubscribePageServices>(EMAIL_CAMPAIGN_UNSUBSCRIBE_PAGE_SERVICES)
